import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { asNumberString } from "../../utils/formatters";
import AnimatedNumber from "react-animated-number";
import ReactTooltip from "react-tooltip";
import { handleTooltip } from "../../utils/handleToolTip";
function NumberDisplay(props) {
  props = {
    value: 23,
    size: 46,
    color: "#4a9bff",
    url: "",
    duration: props.disableAnimation ? 0 : 1000,
    isPercentage: false,
    ...props
  };

  const formatValue = n => {
    return asNumberString(n, props.value) + `${props.isPercentage ? "%" : ""}`;
  };

  return (
    <span data-tip={handleTooltip(props.toolTipContent)} data-for={props.toolTipId} style={{display: "inline-block"}}>
      {props.url !== "" ? (
        <a style={styles.cta} href={props.url} target="_raw_data_tab">
          <AnimatedNumber
            component="h5"
            value={0 || props.value}
            style={{
              margin: 0,
              padding: 0,
              display: "inline",
              fontWeight: "100",
              transition: "0.8s ease-out",
              fontSize: props.size,
              color: props.color
            }}
            className="moneyDisplay"
            duration={props.duration}
            stepPrecision={0}
            formatValue={formatValue}
          />
        </a>
      ) : (
        <AnimatedNumber
          component="h5"
          value={0 || props.value}
          style={{
            margin: 0,
            padding: 0,
            display: "inline",
            fontWeight: "100",
            transition: "0.8s ease-out",
            fontSize: props.size,
            color: props.color
          }}
          className="moneyDisplay"
          duration={props.duration}
          stepPrecision={0}
          formatValue={formatValue}
        />
      )}
      <ReactTooltip id={props.toolTipId} />
    </span>
  );
}

NumberDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.number,
  color: PropTypes.string,
  url: PropTypes.string,
  disableAnimation: PropTypes.bool,
  duration: PropTypes.bool,
  isPercentage: PropTypes.bool,
  toolTipContent: PropTypes.string,
  toolTipId: PropTypes.string
};

let styles = {
  cta: {
    textDecoration: "none"
  }
};

export default Radium(NumberDisplay);
